import { render, staticRenderFns } from "./VSubOrderRefundOrder.vue?vue&type=template&id=2a1dd3f9&scoped=true"
import script from "./VSubOrderRefundOrder.vue?vue&type=script&lang=ts"
export * from "./VSubOrderRefundOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1dd3f9",
  null
  
)

export default component.exports